import { ADVANCED_ABORT_CONTROLLER_PRIVATE } from './privates';
import { ConstructClassWithPrivateMembers } from '../helpers/ClassWithPrivateMembers';
import { IsObject } from '../../helpers';
import { NewAdvancedAbortSignal } from './advanced-abort-signal/implementation';
export function ConstructAdvancedAbortController(instance) {
    ConstructClassWithPrivateMembers(instance, ADVANCED_ABORT_CONTROLLER_PRIVATE);
    const privates = instance[ADVANCED_ABORT_CONTROLLER_PRIVATE];
    privates.signal = NewAdvancedAbortSignal();
}
export function IsAdvancedAbortController(value) {
    return IsObject(value)
        && (value.hasOwnProperty(ADVANCED_ABORT_CONTROLLER_PRIVATE));
}
//# sourceMappingURL=constructor.js.map